<template>
  <div>
    <!--resp menu -->
    <section class="all-categories-side bgWhite pt-3 text-right">
      <div class="d-flex align-items-baseline justify-content-between px-3">
        <AtlasLogo />

        <!-- <router-link to="/" class="mr-3"><img class="menu-logo" style="max-width: 160px;width: 100px" src="@/assets/images/logo.png" alt="angelbar"></router-link> -->
        <button type="button" class="bg-none weight-bold   text-color-666 rounded" @click="allCategoriesToggle()">
          <CloseSvg width="30" />
        </button>


      </div>
      <!-- <div class="accordion pb-3 border-radius15 mt-3" id="accordionExample">
        
        <div v-for="item in menu" :key="item.id" class="card">
          <div class="card-header my-1 pr-3 d-flex justify-content-between" id="headingOne"
            :class="{ 'box--not-children': item.children.length == 0 }">
            <a v-if="item.link" :target="item.new_tab ? '_blank' : '_self'" :href="item.link" @click="close"
              class="d-flex my-auto text-color-444  font-weight-bold">
              <span class="circle-list bg-color-theme rounded-circle mt-1 ml-3"></span>
              {{ item.title }} </a>
            <router-link v-else @click.native="close" class="d-flex my-auto text-color-444  font-weight-bold"
              :to="$router.resolve(findUrl(item.linkable_type, item.linkable_id, item.slug, item.link)).href">
              <span class="circle-list bg-color-theme rounded-circle mt-1 ml-3"></span>
              {{ item.title }}
            </router-link>
            <button v-show="item.children.length != 0" @click="(e) => rotateArrow(e.currentTarget)"
              class="all-categories-side-btn with-event collapsed" type="button" data-toggle="collapse"
              :data-target="'#mobileMenuChild' + item.id" aria-expanded="true" aria-controls="collapseOne">
              <svg class="svg1" width="15" height="15" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" stroke="#444" stroke-width="3"
                  d="M16.2559 4.24279C16.5805 4.56431 16.5827 5.08555 16.2537 5.40707L11.3882 10.1717L11.3023 10.2451C10.9734 10.4897 10.5033 10.4642 10.2048 10.1684C10.043 10.0082 9.96049 9.79753 9.96049 9.58794C9.96049 9.37725 10.043 9.16546 10.207 9.00525L15.0724 4.2395L15.1584 4.16609C15.4873 3.92149 15.9573 3.94706 16.2559 4.24279ZM16.3291 18.6783C16.5802 19.001 16.5535 19.4636 16.256 19.7583C15.9303 20.0798 15.4005 20.0809 15.0725 19.7594L7.74651 12.5828L7.67131 12.4987C7.55732 12.3523 7.5 12.1766 7.5 12.0001C7.5 11.7905 7.58254 11.5798 7.74428 11.4196C8.06998 11.097 8.5998 11.0959 8.92773 11.4174L16.2538 18.594L16.3291 18.6783Z" />
              </svg>
              <svg class="svg2 d-none" width="15" height="15" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M19 8.5L12 15.5L5 8.5" stroke="#444" stroke-width="4" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </button>

          </div>

          <div v-show="item.children.length != 0" :id="'mobileMenuChild' + item.id"
            class="sub-all-categories-side-btn text-right collapse" aria-labelledby="headingOne"
            data-parent="#accordionExample">
            <div class="card-body py-0">
              <ul class="all-categories-sub-menu pr-3">
                <li v-for="child in item.children" :key="child.id">
                  <div class="d-flex">
                    <a v-if="child.link" @click="close" :target="child.new_tab ? '_blank' : '_self'"
                      :href="child.link">{{ child.title }}</a>
                    <router-link v-else @click.native="close" :target="child.new_tab ? '_blank' : '_self'"
                      :to="findUrl(child.linkable_type, child.linkable_id, child.slug)">
                      {{ child.title }}
                    </router-link>
                    <button v-show="child.children.length != 0" @click="(e) => rotateArrow(e.currentTarget)"
                      class="all-categories-side-btn with-event collapsed" type="button" data-toggle="collapse"
                      :data-target="'#mobileMenuChildChild' + child.id" aria-expanded="true"
                      aria-controls="collapseOne">
                      <svg class="svg1" width="15" height="15" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" stroke="#444" stroke-width="3"
                          d="M16.2559 4.24279C16.5805 4.56431 16.5827 5.08555 16.2537 5.40707L11.3882 10.1717L11.3023 10.2451C10.9734 10.4897 10.5033 10.4642 10.2048 10.1684C10.043 10.0082 9.96049 9.79753 9.96049 9.58794C9.96049 9.37725 10.043 9.16546 10.207 9.00525L15.0724 4.2395L15.1584 4.16609C15.4873 3.92149 15.9573 3.94706 16.2559 4.24279ZM16.3291 18.6783C16.5802 19.001 16.5535 19.4636 16.256 19.7583C15.9303 20.0798 15.4005 20.0809 15.0725 19.7594L7.74651 12.5828L7.67131 12.4987C7.55732 12.3523 7.5 12.1766 7.5 12.0001C7.5 11.7905 7.58254 11.5798 7.74428 11.4196C8.06998 11.097 8.5998 11.0959 8.92773 11.4174L16.2538 18.594L16.3291 18.6783Z" />
                      </svg>
                      <svg class="svg2 d-none" width="15" height="15" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M19 8.5L12 15.5L5 8.5" stroke="#444" stroke-width="4" stroke-linecap="round"
                          stroke-linejoin="round" />
                      </svg>
                    </button>
                  </div>
                  <div v-show="child.children.length != 0" :id="'mobileMenuChildChild' + child.id"
                    class="sub-all-categories-side-btn text-right collapse" aria-labelledby="headingOne">
                    <div class="card-body py-0">
                      <ul class="all-categories-sub-menu pr-3">
                        <li v-for="childChild in child.children" :key="childChild.id">
                          <a v-if="childChild.link" @click="close" :target="childChild.new_tab ? '_blank' : '_self'"
                            :href="childChild.link">{{ childChild.title }}</a>
                          <router-link v-else @click.native="close" :target="childChild.new_tab ? '_blank' : '_self'"
                            :to="findUrl(childChild.linkable_type, childChild.linkable_id, childChild.slug)">
                            {{ childChild.title }}
                          </router-link>
                        </li>
                      </ul>
                    </div>
                  </div>

                </li>
              </ul>
            </div>
          </div>
        </div>


      </div> -->
      <nav class=" pb-3 border-radius15 res-menu mt-3">
        <ul v-if="menu && menu.length" class="menu-box">
          <li v-for="item in menu" :key="item.id" class="card">
            <template v-if="item.children && item.children.length">
              <details name="parent-menu">
                <summary>
                  <span class="text-color-444  font-weight-bold">
                    {{ item.title }}
                  </span>
                  <span class="arrow-parent d-flex">
                    <arrow />
                  </span>
                </summary>
                <ul class="child-menu-box">
                  <li class="more-show-title">
                    <a @click="close" v-if="item.link" :target="item.new_tab ? '_blank' : '_self'" :href="item.link"
                      class="d-flex my-auto text-color-444  font-weight-bold">
                      <span class="circle-list bg-color-theme rounded-circle mt-1 ml-3"></span>
                      {{ item.title }} </a>
                    <router-link @click.native="close" v-else class="d-flex my-auto text-color-444  font-weight-bold"
                      :to="$router.resolve(findUrl(item.linkable_type, item.linkable_id, item.slug, item.link)).href">
                      <span class="circle-list bg-color-theme rounded-circle mt-1 ml-3"></span>
                      {{ `مشاهده همه محصولات ${item.title}` }}
                    </router-link>
                  </li>
                  <li v-for="subItem in item.children" :key="subItem.id">
                    <template v-if="subItem.children.length">
                      <details name="chile-menu">
                        <summary>
                          <span class="text-color-444  font-weight-bold">
                            {{ subItem.title }}
                          </span>
                          <span class="arrow-child d-flex">
                            <arrow />
                          </span>
                        </summary>
                        <ul class="sub-child-menu-box">
                          <li class="more-show-title">
                            <a @click="close" v-if="subItem.link" :target="subItem.new_tab ? '_blank' : '_self'"
                              :href="subItem.link" class="d-flex my-auto text-color-444  font-weight-bold">
                              <span class="circle-list bg-color-theme rounded-circle mt-1 ml-3"></span>
                              {{ subItem.title }} </a>
                            <router-link @click.native="close" v-else
                              class="d-flex my-auto text-color-444  font-weight-bold"
                              :to="$router.resolve(findUrl(subItem.linkable_type, subItem.linkable_id, subItem.slug, subItem.link)).href">
                              <span class="circle-list bg-color-theme rounded-circle mt-1 ml-3"></span>
                              {{ `مشاهده همه محصولات ${subItem.title}` }}
                            </router-link>
                          </li>
                          <li v-for="subItem2 in subItem.children" :key="subItem2.id">
                            <a v-if="subItem2.link" @click="close" :target="subItem2.new_tab ? '_blank' : '_self'"
                              :href="subItem2.link" class="d-flex my-auto text-color-444  font-weight-bold">
                              <span class="circle-list bg-color-theme rounded-circle mt-1 ml-3"></span>
                              {{ subItem2.title }} </a>
                            <router-link @click.native="close" v-else
                              class="d-flex my-auto text-color-444  font-weight-bold"
                              :to="$router.resolve(findUrl(subItem2.linkable_type, subItem2.linkable_id, subItem2.slug, subItem2.link)).href">
                              <span class="circle-list bg-color-theme rounded-circle mt-1 ml-3"></span>
                              {{ subItem2.title }}
                            </router-link>
                          </li>
                        </ul>
                      </details>
                    </template>
                    <template v-else>
                      <a @click="close" v-if="subItem.link" :target="subItem.new_tab ? '_blank' : '_self'"
                        :href="subItem.link" class="d-flex my-auto text-color-444  font-weight-bold">
                        <span class="circle-list bg-color-theme rounded-circle mt-1 ml-3"></span>
                        {{ subItem.title }} </a>
                      <router-link @click.native="close" v-else class="d-flex my-auto text-color-444  font-weight-bold"
                        :to="$router.resolve(findUrl(subItem.linkable_type, subItem.linkable_id, subItem.slug, subItem.link)).href">
                        <span class="circle-list bg-color-theme rounded-circle mt-1 ml-3"></span>
                        {{ subItem.title }}
                      </router-link>
                    </template>
                  </li>
                </ul>
              </details>
            </template>
            <template v-else>
              <a @click="close" v-if="item.link" :target="item.new_tab ? '_blank' : '_self'" :href="item.link"
                class="d-flex my-auto text-color-444  font-weight-bold">
                <span class="circle-list bg-color-theme rounded-circle mt-1 ml-3"></span>
                {{ item.title }} </a>
              <router-link @click.native="close" v-else class="d-flex my-auto text-color-444  font-weight-bold"
                :to="$router.resolve(findUrl(item.linkable_type, item.linkable_id, item.slug, item.link)).href">
                <span class="circle-list bg-color-theme rounded-circle mt-1 ml-3"></span>
                {{ item.title }}
              </router-link>
            </template>
          </li>
        </ul>
      </nav>
    </section><!--resp menu button-->
    <div class="all-categories-resp" @click="allCategoriesToggle()"></div> <!-- close menu by click to body-->

  </div>

</template>

<script>
import findUrl from "@/libraries/links/LinkResolver";
import CloseSvg from "@/components/svgs/CloseSvg";
import AtlasLogo from "@/parts/Front/components/AtlasLogo";
import arrow from "./icons/arrow.vue";
export default {
  name: "RespMenu",
  components: { CloseSvg, AtlasLogo, arrow },
  watch: {

  },
  methods: {
    gotoCategoryAndClose(id, slug) {
      this.$router.push({ 'name': 'product.category', params: { 'category': id, 'slug': slug } })
      this.allCategoriesToggle();
    },
    close() {
      setTimeout(() => {
        let hasClassClose = document.getElementById('all-categories').classList.contains('all-categories-close');
        if (hasClassClose) {
          this.allCategoriesToggle();
        }
      }, 200)
    },
    findUrl,
    allCategoriesToggle() {
      document.getElementById('all-categories').classList.toggle('all-categories-close');
      let hasClassClose = document.getElementById('all-categories').classList.contains('all-categories-close');
      let catSide = document.getElementsByClassName('all-categories-side')[0];
      let allCategoriesResp = document.querySelectorAll('.all-categories-resp')[0];

      // let wrapper = document.getElementsByClassName('wrapper')[0];
      if (hasClassClose) {
        window.addEventListener("popstate", this.checkBackButton);
        this.$router.push(this.$route.fullPath + "#resp-menu");
        catSide.style.right = "0px";
        allCategoriesResp.style.display = "block";
        // if(window.screen.width >= 1200){
        // wrapper.style.paddingRight="250px";
        // }
      }
      else {
        // if(window.screen.width >= 1200){
        //     wrapper.style.paddingRight="0";
        // }
        catSide.style.right = "-103%";
        allCategoriesResp.style.display = "none";
        this.$router.replace(this.$route.fullPath.replace("#resp-menu", "")).catch(e => { });
        window.removeEventListener("popstate", this.checkBackButton);
      }
    },
    rotateArrow(el) {
      el.children.forEach(child => {
        if (child.classList.contains('d-none')) {
          child.classList.remove('d-none');
        }
        else {
          child.classList.add('d-none');
        }
      })
    },
    checkBackButton() {
      this.allCategoriesToggle();
    }
  },
  mounted() {
  },
  beforeDestroy() {
    window.removeEventListener("popstate", this.checkBackButton);
  },
  computed: {
    // دریافت منو ها از ویو ایکس
    menu() {
      if (this.$store.getters["front/getHomeData"] == null) {
        return this.$store.getters["front/getHomeData"]
      } else {
        return this.$store.getters["front/getHomeData"].menu.header;
      }
    },
    // دریافت دسته بندی ها ازویوایکس
    category() {
      if (this.$store.getters["front/getHomeData"] == null) {
        return this.$store.getters["front/getHomeData"]
      } else {

        return this.$store.getters["front/getHomeData"].categories;
      }
    }
  }
}
</script>
<style scoped>
details>summary::-webkit-details-marker {
  display: none;
}

details>summary {
  list-style: none;
}

/* برای فایرفاکس */
details>summary {
  list-style-type: none;
}

.more-show-title {
  display: flex;
  justify-content: center;
}

.all-categories-side .all-categories-side-btn {
  flex-grow: 100;
  justify-content: flex-end;
  display: flex;
}

.all-categories-side .res-menu>li {
  padding-inline: 16px;
}

.menu-box li {
  padding-block: 8px;
}

.menu-box>.card {
  border-bottom: 1px solid #afafaf;
  padding-block: 16px;
  padding-inline: 16px;

}

li {
  list-style-type: none;
}

.res-menu summary::marker {
  content: "";
  display: none;
}

.child-menu-box {
  padding: 0 16px;
}

.sub-child-menu-box {
  padding: 0 16px;

}

.res-menu summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.res-menu details[open] .arrow-parent {
  transform: rotate(-90deg);
}

.child-menu-box details[open] .arrow-child {
  transform: rotate(-90deg);
}

/*details[open] .icon-summery[data-v-ecd1c446] {
    transform: translateY(5px) rotate(-90deg);
}*/




.box--not-children {
  padding-block: .4rem;
}

.circle-list {
  display: none !important;
}

.all-categories-sub-menu {
  list-style-type: none;
}

.all-categories-sub-menu a {
  list-style-type: none;
  color: #000;
}

#accordionExample .card {
  border-bottom: 1px solid rgb(175, 175, 175);
}

.all-categories-sub-menu>li {
  margin-bottom: 11px;
}

.bgWhite {
  background-color: white;
}
</style>
